import { Component, OnDestroy, OnInit } from '@angular/core';
import { fadeUp } from 'shared';

import { BasePopupComponent } from '../base-popup/base-popup.component';

export interface SnackbarSettings {
    text: string;
    actions?: Array<SnackbarAction>;
    duration?: number;
}

interface SnackbarAction {
    primary?: boolean;
    label: string;
    onClick: (snackbar: SnackbarComponent) => void;
}

@Component({
    selector: 'app-snackbar',
    templateUrl: './snackbar.component.html',
    styleUrls: ['./snackbar.component.scss'],
    animations: [fadeUp('popup')],
})
export class SnackbarComponent extends BasePopupComponent<SnackbarComponent> implements OnInit, OnDestroy {
    public _progress = 0;

    public text = '';
    public actions: Array<SnackbarAction> = [];
    public duration = 5000;

    private _intervalId: ReturnType<typeof setInterval> | null = null;
    private _removeTimeoutId: ReturnType<typeof setTimeout> | null = null;

    public constructor() {
        super();
        this.popupOptions.padding = 0;
        this.popupOptions.closeByClickOutside = false;
        this.popupOptions.pointerEvents = 'none';
        this.popupOptions.closeByEsc = false;
    }

    public ngOnInit(): void {
        super.ngOnInit();
        this.restart();
    }

    public ngOnDestroy(): void {
        this.clearTimers();
    }

    /**
     * Restarts the snackbar progress/timer. Optionally override duration.
     */
    public restart(duration?: number): void {
        if (duration > 0) {
            this.duration = duration;
        }
        this.clearTimers();
        this._progress = 0;

        const start = performance.now();
        this._intervalId = setInterval(this.updateProgress(start), 50);
    }

    private clearTimers(): void {
        if (this._intervalId) {
            clearInterval(this._intervalId);
            this._intervalId = null;
        }
        if (this._removeTimeoutId) {
            clearTimeout(this._removeTimeoutId);
            this._removeTimeoutId = null;
        }
    }

    private updateProgress(start: number): () => void {
        return () => {
            const now = performance.now();
            const elapsed = now - start;
            const progress = Math.min(elapsed / this.duration, 1);
            this._progress = progress;
            if (progress >= 1) {
                this.clearTimers();
                // Allow a short delay to finish any CSS animation before removing
                this._removeTimeoutId = setTimeout(() => this.__DOM_COMPONENT.remove(), 500);
            }
        };
    }
}
